import React from 'react';
import { Box, Stack, Button, Typography, Divider } from '@mui/material';
import { Add, Notes } from '@mui/icons-material';
import NotesGrid from '../notes/NotesGrid';
import { AddNoteDialog } from '../notes/AddNoteDialog';
import { ViewNoteDialog } from '../notes/ViewNoteDialog';
import { useAppSelector, useAppDispatch } from '../../../../../app/hooks';
import { openAddNoteDialog } from '../../../state';
import { useNotesManagement } from '../../../hooks/useNotesManagement';

const NotesSection: React.FC = () => {
  const dispatch = useAppDispatch();
  const { showAddNoteDialog } = useAppSelector(state => state.ticket.ui);
  const { totalNotes, hasNotes } = useNotesManagement();

  const handleAddNote = () => {
    dispatch(openAddNoteDialog());
  };

  return (
    <Stack spacing={2}>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" spacing={1} alignItems="center">
          <Notes color="primary" />
          <Typography variant="h6" color="primary">
            Notes {hasNotes && `(${totalNotes})`}
          </Typography>
        </Stack>
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={handleAddNote}
          sx={{
            backgroundColor: '#162346',
            '&:hover': { backgroundColor: '#1a2a52' }
          }}
        >
          Add Note
        </Button>
      </Stack>

      <Divider />

      {/* Notes Grid */}
      <NotesGrid />

      {/* Add Note Dialog */}
      {showAddNoteDialog && <AddNoteDialog />}
      
      {/* View Note Dialog */}
      <ViewNoteDialog />
    </Stack>
  );
};

export default NotesSection;
